const PRIORITY_LABEL: Record<string, { label: string; icon: string; cls: string }> = {
  critical: { label: "Critical", icon: "🔴", cls: "badge-critical" },
  high: { label: "High", icon: "🟠", cls: "badge-high" },
  medium: { label: "Medium", icon: "🟡", cls: "badge-medium" },
  low: { label: "Low", icon: "🟢", cls: "badge-low" },
};

const STATUS_LABEL: Record<string, string> = {
  new: "New",
  acknowledged: "Acknowledged",
  assigned: "Assigned",
  in_progress: "In Progress",
  waiting_info: "Waiting for Information",
  workaround_applied: "Workaround Applied",
  resolved: "Resolved",
  closed: "Closed",
  reopened: "Reopened",
};

export function PriorityBadge({ priority }: { priority: string }) {
  const p = PRIORITY_LABEL[priority] ?? { label: priority, icon: "•", cls: "badge-status" };
  return (
    <span className={`badge ${p.cls}`}>
      <span aria-hidden="true">{p.icon}</span> {p.label}
    </span>
  );
}

export function StatusBadge({ status }: { status: string }) {
  return <span className="badge badge-status">{STATUS_LABEL[status] ?? status}</span>;
}

export { STATUS_LABEL, PRIORITY_LABEL };
